"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _mobx = require("mobx");
var _mobxReact = require("mobx-react");
var _dec, _class;
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ScrollRestoration = (_dec = (0, _mobxReact.inject)('store'), _dec(_class = (0, _mobxReact.observer)(_class = /*#__PURE__*/function (_Component) {
  function ScrollRestoration() {
    var _this;
    _classCallCheck(this, ScrollRestoration);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ScrollRestoration, [].concat(args));
    /**
     * Executes either before or after the path change
     * and only if the popstate event was fired
     */
    _defineProperty(_this, "handlePopstate", function () {
      var ui = _this.props.store.ui;
      ui.shouldScrollBeRestoredForNextRoute = true;
    });
    /**
     * Executes after the path change
     */
    _defineProperty(_this, "handlePathChange", function (change) {
      var ui = _this.props.store.ui;

      // The old view is still around, so a snapshot
      // of its scroll position can be taken:
      ui.saveScrollFor(change.oldValue);
      ui.shouldScrollBeRestored = new Promise(function (resolve) {
        // Tackle the handlePopstate/handlePathChange
        // race condition:
        window.setTimeout(function () {
          resolve(ui.shouldScrollBeRestoredForNextRoute);
          ui.shouldScrollBeRestoredForNextRoute = false;
        });
      });
    });
    return _this;
  }
  _inherits(ScrollRestoration, _Component);
  return _createClass(ScrollRestoration, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var router = this.props.store.router;

      // Takes ownership of any scroll changes from Chrome:
      if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
      }
      this.disposeObserver = (0, _mobx.observe)(router, 'currentPath', this.handlePathChange);
      window.addEventListener('popstate', this.handlePopstate);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('popstate', this.handlePopstate);
      this.disposeObserver();
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children || null;
    }
  }]);
}(_react.Component)) || _class) || _class);
var _default = exports["default"] = ScrollRestoration;
//# sourceMappingURL=index.js.map